<template>
  <div class="d-flex flex-column">
    <DxDataGrid v-bind="gridProperties" :data-source="gridSource" ref="grid" class="dx-card wide-card grid-tramites" @selection-changed="onSelectionChanged">
      <DxToolbar>
        <DxItem location="after" template="exportButtonTemplate" />
        <DxItem location="after" template="exportRepsolButtonTemplate" />
        <DxItem v-bind="getResetFiltersGridBtn(() => grid)" />
        <DxItem v-bind="getResetStateGridBtn(() => grid)" />
        <DxItem v-bind="getColumnChooserBtn()" />
      </DxToolbar>
      <DxColumn data-field="CodigoSecuencial" :caption="$t('tramiteEnergia.idOperacion')" format="0000000000" />
      <DxColumn data-field="FechaAlta" :caption="$t('tramiteEnergia.fechaAlta')" data-type="date" format="dd/MM/yyyy" />
      <DxColumn data-field="NombreComercial" :caption="$t('tramiteEnergia.comercial')" />
      <DxColumn data-field="NombreEmpresaAgente" :caption="$t('tramiteEnergia.empresaAgente')"></DxColumn>
      <DxColumn data-field="TipoEmpresaAgente" :caption="$t('tramiteEnergia.tipoEmpresaAgente')" cell-template="tipoEmpresaAgenteTemplate">
        <DxLookup v-bind="getLookup('empresa_agente', 'tipo')" />
      </DxColumn>
      <DxColumn data-field="CodigoSubtipo" :caption="$t('tramiteEnergia.subtipoEmpresaColaboradora')" cell-template="subtipoEmpresaColaboradoraTemplate">
        <DxLookup v-bind="getLookup('empresa_colaboradora', 'subtipo')"></DxLookup>
      </DxColumn>
      <DxColumn data-field="NombreAgente" :caption="$t('tramiteEnergia.agente')" />
      <DxColumn data-field="NombreResponsable" :caption="$t('tramiteEnergia.responsable')" />
      <DxColumn data-field="IdEmpresaServicios" :visible="false" />
      <DxColumn data-field="NombreEmpresaServicios" :caption="$t('tramiteEnergia.comercializadora')" />
      <DxColumn data-field="CifTitular" :caption="$t('tramiteEnergia.cifTitular')" />
      <DxColumn data-field="DocumentoTitular" :caption="$t('tramiteEnergia.documentoTitular')" />
      <DxColumn data-field="CodigoEstado" :caption="$t('tramiteEnergia.estado')" cell-template="estadoTemplate">
        <DxLookup v-bind="getLookup('operaciones', 'estado')" />
      </DxColumn>
      <DxColumn data-field="TieneServiciosAdicionales" :caption="$t('tramiteEnergia.tieneServiciosAdicionales')" cell-template="booleanTemplate">
        <DxLookup v-bind="getColumnLookupBoolean()"></DxLookup>
      </DxColumn>
      <DxColumn data-field="TipoSuministro" :caption="$t('tramiteEnergia.tipoSuministro')">
        <DxLookup column-auto-width="true" v-bind="getLookup('operaciones', 'tipo_suministro')" />
      </DxColumn>
      <DxColumn data-field="TarifaAcceso" :caption="$t('tramiteEnergia.tarifaAcceso')" />
      <DxColumn data-field="Cups" :caption="$t('tramiteEnergia.cups')" />
      <DxColumn data-field="IdExternoTramite" :caption="$t('tramiteEnergia.grid.idExternoTramite')" />
      <DxColumn data-field="IdExternoOperacion" :caption="$t('tramiteEnergia.grid.idExternoOperacion')" />
      <DxColumn data-field="Comision" :caption="$t('tramiteEnergia.comision')" data-type="number">
        <DxFormat v-bind="currencyFormat()"></DxFormat>
      </DxColumn>
      <DxColumn data-field="Retrocomision" :caption="$t('tramiteEnergia.retrocomision')" data-type="number" :calculate-cell-value="formatRetrocomision">
        <DxFormat v-bind="currencyFormat()"></DxFormat>
      </DxColumn>
      <DxColumn data-field="FechaActivacion" :caption="$t('tramiteEnergia.fechaActivacion')" data-type="date" format="dd/MM/yyyy" />
      <DxColumn data-field="FechaBaja" :caption="$t('tramiteEnergia.fechaBaja')" data-type="date" format="dd/MM/yyyy" />
      <DxColumn data-field="FechaModificacion" :caption="$t('tramiteEnergia.fechaUltModificacion')" data-type="date" format="dd/MM/yyyy" />
      <DxColumn data-field="NombreUsuarioUltimaModificacion" :caption="$t('tramiteEnergia.nombreUsuarioUltimaModificacion')" />
      <DxColumn data-field="CodigoEstadoLiquidacion" :caption="$t('operaciones.grid.liquidado')" cell-template="liquidadoTemplate">
        <DxLookup v-bind="getLookup('operaciones', 'liquidado')" />
      </DxColumn>
      <DxColumn type="buttons" :caption="$t('tramites.grid.acciones')" :fixed="true" fixed-position="right" width="100px" :buttons="[
        {
          cssClass: 'btn btn-link text-decoration-none btn-sm',
          text: $t('operaciones.grid.ir_a_chat'),
          icon: 'fa-regular fa-comment-dots text-success',
          onClick: (e: any) => irAChat(e)
        },
        {
          cssClass: 'btn btn-link text-decoration-none btn-sm',
          text: $t('operaciones.grid.ver_detalle'),
          icon: 'fa-solid fa-magnifying-glass text-success',
          onClick: (e: any) => verDetalle(e)
        }
      ]" />
      <DxColumnFixing :enabled="true" />

      <template #tipoEmpresaAgenteTemplate="{ data }">
        <div :class="[
          `d-inline-block rounded py-1 px-2 `,
          `tipoEmpresaAgente ${data.value.replace(' ', '')}`,
        ]">
            {{ $t(`empresa_agente.tipo.${data.value}`) }}
        </div>
      </template>
      <template #estadoTemplate="{ data }">
        <div :class="[
          `d-inline-block rounded py-1 px-2 `,
          `estado-operacion ${data.value.replace(' ', '')}`,
        ]">
            {{ $t(`operaciones.estado.${data.value}`) }}
        </div>
      </template>
      <template #liquidadoTemplate="{ data }">
        <div :class="[
          `d-inline-block rounded py-1 px-2 `,
          `estado-liquidacion ${data.value.replace(' ', '')}`,
        ]">
            {{ $t(`operaciones.liquidado.${data.value}`) }}
        </div>
      </template>
      <template #booleanTemplate="{ data }">
        <BooleanTemplate :value="data.value" />
      </template>
      <template #exportButtonTemplate>
        <button @click="onExporting" class="btn btn-sm btn-light d-flex align-items-center gap-2 m-2">
          <i class="fas fa-file-excel fa-lg"></i>
          <span class="text-primary">{{ $t("shared.ui.buttons.exportToExcel") }}</span>
        </button>
      </template>
      <template #exportRepsolButtonTemplate>
        <button @click="onExportRepsol" :disabled="!canExportTramitesRepsol" class="btn btn-sm btn-light d-flex align-items-center gap-2 m-2">
          <img src="../../assets/images/file-repsol.svg" alt="Exportar Excel Repsol" class="repsol-icon" />
          <span class="text-primary">{{ $t('tramites.grid.exportarExcelRepsol') }}</span>
        </button>
      </template>
      <template #subtipoEmpresaColaboradoraTemplate="{ data }">
        <div v-if="data.value" :class="[`d-inline-block rounded py-1 px-2`, `subtipoEmpresaColaboradora ${data.value.replace(' ', '')}`]">
            {{ $t(`empresa_colaboradora.subtipo.${data.value}`) }}
        </div>
      </template>
      <DxMasterDetail :enabled="true" template="masterDetailTemplate" />
      <template #masterDetailTemplate="{ data: tramite }">
        <tramites-grid-detail :template-data="tramite" />
      </template>
    </DxDataGrid>
  </div>
</template>

<script setup lang="ts">
import { useApi } from "@api/integration";
import {
  DxColumn,
  DxDataGrid,
  DxFormat,
  DxLookup,
  DxMasterDetail,
  DxColumnFixing,
  DxItem,
  DxToolbar,
} from "devextreme-vue/data-grid";
import {
  currencyFormat,
  getDefaultGridProperties,
  getLookup,
  getColumnLookupBoolean,
  exportGridToExcel,
  getColumnChooserBtn,
  getResetFiltersGridBtn,
  getResetStateGridBtn,
  getDefaultGridWithStateStoringProperties,
} from "@helpers/grid-helper";
import { useModalService } from "@services/modal-service";
import type CustomStore from "devextreme/data/custom_store";
import { onMounted, ref } from "vue";
import TramitesGridDetail from "@/components/tramites-energia/TramitesGridDetail.vue";
import type DevExpress from "devextreme";
import type { ITramiteEnergiaGridRm } from "./models/ITramiteEnergiaGridRm";
import saveAs from "file-saver";
import BooleanTemplate from "@/.shared/components/BooleanTemplate.vue";
import { TipoOperacionEnum } from "@/.shared/enums/TipoOperacionEnum";
import { useRouter } from "@/.shared/services/routing-services";


const props = defineProps({
  idOperacion: {
    type: String,
    required: false,
  },
});

const api = useApi();
const gridSource = ref<CustomStore>();
const grid = ref<DxDataGrid>();
const router = useRouter();

const gridProperties = {
  ...getDefaultGridWithStateStoringProperties("tramites-energia-grid-state.v7", () => grid.value)
  , selection: {
    mode: "multiple"
  },
  hoverStateEnabled: true,
  rowAlternationEnabled: false
};

const canExportTramitesRepsol = ref(false);

const onSelectionChanged = (e: DevExpress.ui.dxDataGrid.SelectionChangedEvent) => {
  const tramitesSeleccionados = e.selectedRowsData as ITramiteEnergiaGridRm[];

  if (tramitesSeleccionados.length > 0 && tramitesSeleccionados.every(t => t.EsExportableRepsol))
    canExportTramitesRepsol.value = true;
  else
    canExportTramitesRepsol.value = false;
};

onMounted(async () => {
  gridSource.value = api.apiStore({
    key: "IdTramite",
    load: await api.toStandardApiFunction("getTramitesEnergiaForGrid", { showLoading: false })
  });
});

const verDetalle = async (data: DevExpress.ui.dxDataGrid.ColumnButtonClickEvent) => {
  await router.push({ name: "tramite", query: { idOperacion: data.row?.data.IdOperacion, tipoOperacion: TipoOperacionEnum.Energia, idTramite: data.row?.data.IdTramite, tipoTramite: data.row?.data.TipoSuministro } });
};

const irAChat = async (data: DevExpress.ui.dxDataGrid.ColumnButtonClickEvent) => {
  const rutaBO = import.meta.env.VITE_BASE_URL;
  const url = `${rutaBO}/comunicaciones-operacion/${data.row?.data.IdOperacion}/${data.row?.data.CodigoSecuencial.toString().padStart(10, '0')}/${TipoOperacionEnum.Energia}`;
  window.open(url, '_blank');
};

const formatRetrocomision = (rowData: ITramiteEnergiaGridRm) => {
  return rowData.Retrocomision ? -Math.abs(rowData.Retrocomision) : rowData.Retrocomision;
};

const onExporting = async () => {
  await exportGridToExcel(
    grid.value!.instance,
    'Tramites.xlsx',
    'Tramites',
    true
  );
};

const onExportRepsol = async () => {
  const tramitesSeleccionados = grid.value?.instance?.getSelectedRowKeys() as string[];

  var result = await api.callStandardApi("getExportacionExcelRepsol", { showLoading: true, isFile: true }, tramitesSeleccionados);
  saveAs(result);
}

defineExpose({
  refreshGrid: () => {
    grid.value?.instance?.refresh();
  }
});

</script>

<style lang="scss" scoped>


.lupa,
.chat {
  color: var(--text-success-default);
}

.repsol-icon {
  height: 18px;
  margin-bottom: 2px;
}

.detalle {
  color: var(--text-primary-default);
  cursor: pointer;
}
</style>
<style>
.grid-tramites .dx-datagrid {
  max-height: calc(100vh - 250px);
}
</style>
